module.exports = __webpack_public_path__ + "static/media/pack_super_cat_en_768x350.1144ca0e.png";